module.exports = __webpack_public_path__ + "static/media/SteeringFpIImageOnlyViz20.7adc0b02.mp4";